import { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TermsModal = ({ isOpen, onClose, type }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const content = type === 'terms' ? {
    title: 'Terms of Service',
    sections: [
      {
        heading: '1. Acceptance of Terms',
        text: `By accessing and using SocialSeeds ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.`
      },
      {
        heading: '2. Use License',
        text: `Permission is granted to temporarily access the Service for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:\n• Modify or copy the materials\n• Use the materials for any commercial purpose\n• Attempt to decompile or reverse engineer any software contained on the Service\n• Remove any copyright or other proprietary notations from the materials`
      },
      {
        heading: '3. Account Responsibilities',
        text: `You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account.`
      },
      {
        heading: '4. Service Modifications',
        text: `SocialSeeds reserves the right to modify or discontinue, temporarily or permanently, the Service with or without notice. You agree that SocialSeeds shall not be liable to you or any third party for any modification, suspension, or discontinuance of the Service.`
      },
      {
        heading: '5. Limitation of Liability',
        text: `In no event shall SocialSeeds or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the Service.`
      }
    ]
  } : {
    title: 'Privacy Policy',
    sections: [
      {
        heading: '1. Information We Collect',
        text: `We collect information you provide directly to us, including:\n• Account information (name, email, password)\n• Business information (company name, industry, size)\n• Social media account connections and credentials\n• Content you create, post, or schedule through our Service\n• Usage data and analytics about how you interact with our Service`
      },
      {
        heading: '2. How We Use Your Information',
        text: `We use the information we collect to:\n• Provide, maintain, and improve our Service\n• Process and complete transactions\n• Send you technical notices and support messages\n• Respond to your comments and questions\n• Analyze usage patterns and trends\n• Detect, prevent, and address technical issues and security threats`
      },
      {
        heading: '3. Information Sharing',
        text: `We do not sell your personal information. We may share your information only in the following circumstances:\n• With your consent\n• With service providers who perform services on our behalf\n• To comply with legal obligations\n• To protect our rights and prevent fraud\n• In connection with a business transfer or acquisition`
      },
      {
        heading: '4. Data Security',
        text: `We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.`
      },
      {
        heading: '5. Your Rights',
        text: `You have the right to:\n• Access your personal information\n• Correct inaccurate data\n• Request deletion of your data\n• Object to processing of your data\n• Export your data in a portable format\n• Withdraw consent at any time`
      },
      {
        heading: '6. Contact Us',
        text: `If you have questions about this Privacy Policy, please contact us at:\nEmail: privacy@socialseeds.com\nAddress: 123 Growth Street, San Francisco, CA 94102`
      }
    ]
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-2xl max-h-[80vh] bg-card rounded-lg shadow-modal border border-border overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl font-semibold text-foreground">{content?.title}</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-6">
            {content?.sections?.map((section, index) => (
              <div key={index}>
                <h3 className="text-base font-semibold text-foreground mb-2">
                  {section?.heading}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">
                  {section?.text}
                </p>
              </div>
            ))}
          </div>
          
          <div className="mt-6 p-4 rounded-lg bg-muted/50 border border-border">
            <p className="text-xs text-muted-foreground">
              Last updated: December 8, 2025
            </p>
          </div>
        </div>
        
        <div className="p-6 border-t border-border">
          <Button onClick={onClose} variant="default" fullWidth>
            I Understand
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;